export const GET_COMMUNITY = "GET_COMMUNITY";